import { API } from '~apis/axios/instance';
import { DemoStatusResponse } from '~types/demo';
import { ResponseBaseWithData } from '~types/response';

export const getDemoStatus = (companyId: string) => {
  return API.get<ResponseBaseWithData<DemoStatusResponse>>(
    `/api/v3/companies/${companyId}/demo/status`,
  );
};
